import React from 'react';

type KpiWorkunitGridData = {
  charge: number | null;
};

const WorkloadCell = React.memo((row: KpiWorkunitGridData) => <div>{row?.charge ? row.charge : 0}</div>);

export default WorkloadCell;
